export default __webpack_public_path__ + "static/IncentiveMechanism@2x-ba29cfc99298981e8bf22e53de4d6517.png";